
export const THEME_HIDE_MESSAGE = '[THEME] MESSAGE CLOSE';
export const THEME_SHOW_MESSAGE = '[THEME] MESSAGE SHOW';
export const THEME_START_LOAIDING = '[THEME] START LOADING';
export const THEME_STOP_LOADING = '[THEME] STOP LOADING';
export const THEME_SHOW_ERROR = '[THEME] SHOW ERROR';
